import { useSelector } from "react-redux";
import type { RootModel } from "models/app";

export const useCurrentLiveRadioFromState = () => {
    const liveRadio = useSelector((root: RootModel) => root.liveRadio.currentRadio);
    return liveRadio;
};
